'use client';
import styles from './tips.module.scss';

export default function SaleTips({ labels, saleTextColor, skuDiscountText }: any) {
  const displayLabels: any = {};
  if (labels) {
    if (labels.discount) {
      displayLabels.discount = labels.discount;
    } else if (labels.saveX) {
      displayLabels.saveX = labels.saveX;
    }
    if (labels.onlyXLeft) {
      displayLabels.onlyXLeft = labels.onlyXLeft;
    }
    if (labels.onlyLeft) {
      displayLabels.onlyLeft = labels.onlyLeft;
    }
  }

  return displayLabels ? (
    <div className={styles.tagGroup}>
      {skuDiscountText ? (
        <span className={styles.skuDiscountText}>{skuDiscountText}</span>
      ) : (
        <>
          {displayLabels.discount && (
            <span className={styles.tips1} style={{ color: saleTextColor ? '#4843B8' : '#c82314' }}>
              {labels?.discount}
            </span>
          )}
          {displayLabels.saveX && (
            <span className={styles.tips1} style={{ color: saleTextColor ? '#4843B8' : '#c82314' }}>
              {labels?.saveX}
            </span>
          )}
          {displayLabels?.onlyXLeft && <span className={styles.tips2}>{labels?.onlyXLeft}</span>}
          {displayLabels?.onlyLeft && <span className={styles.tips3}>{labels?.onlyLeft}</span>}
          <span className={styles.placeHolder}></span>
        </>
      )}
    </div>
  ) : (
    <div className={styles.tagGroup}>
      <span className={styles.placeHolder}></span>
    </div>
  );
}
